import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  // AccordionIcon,
  Box,
} from "@chakra-ui/react";

import { AddIcon, MinusIcon } from '@chakra-ui/icons'
const AccordionCard = () => {
  return (

    <>
    <div>
      <div>
    <Accordion
      allowToggle
      className="m-auto mt-10 w-[100%] md:w-[400px] lg:w-[1100px] py-10"
      >
        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Eligibility Criteria
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon' />
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} pt={2} className="mt-2">
        <li className='m-1'>The minimum requirements for admission in a Bachelor degree program in Computer Science, is at least 50% marks in Intermediate (HSSC) examination with Mathematics or equivalent.</li>
                <li className='m-1'>The students who have not studied Mathematics at intermediate level have to pass deficiency courses of Mathematics (06 credits) in first two semesters.</li>
                <li className='m-1'>Applicant must clear Admission/aptitude Test of EIMS or (GAT/HAT)</li>
                <li className='m-1'>Interview conducted by the institute</li>
                <li className='m-1'>Required credentials as per HEC policy</li>
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>

        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Specializations
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
         {/* <h4>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, blanditiis ratione perspiciatis modi, illum consequatur doloribus voluptatem ducimus eum facere vitae, libero possimus sit ipsam at voluptate dolore. Fuga, eos.</h4> */}
          {/* <li>Finance</li>
          <li>Marketing</li>
          <li>Human Resource Management</li>
          <li>Management Information System</li> */}
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>
        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Learning Outcomes
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
          {/* <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil nisi ducimus, placeat omnis magni labore quasi fugit unde assumenda? Hic ipsam eos recusandae impedit vero quasi suscipit molestias totam delectus!</li> */}
          {/* <li>Marketing</li> */}
          {/* <li>Human Resource Management</li> */}
          {/* <li>Management Information System</li> */}
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>
        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Career Options
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
          {/* <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil nisi ducimus, placeat omnis magni labore quasi fugit unde assumenda? Hic ipsam eos recusandae impedit vero quasi suscipit molestias totam delectus!</li> */}
          {/* <li>Marketing</li> */}
          {/* <li>Human Resource Management</li> */}
          {/* <li>Management Information System</li> */}
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>
        <div>

      <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">
    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Admission Criteria
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon'/>
            )}
          </AccordionButton>
        </h2>
      
        <AccordionPanel pb={4} className="mt-2">
         {/* <h3>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti saepe, natus fugit fugiat rerum magnam iste id harum quas voluptatibus soluta eveniet excepturi nesciunt distinctio corporis neque aut debitis officia?</h3> */}
          <li>At least 50% marks in intermediate (or equivalent).</li>
          <li>Applicant must clear Admission/aptitude Test of EIMS or (GAT/HAT)</li>
          <li>Interview conducted by the institute</li>
          <li>Required credentials as per HEC policy</li>
        </AccordionPanel>
        </>
      )}
      </AccordionItem>
        </div>

        <div>
           <AccordionItem className="w-[100%] p-4 bg-gray-200 justify-items-center rounded-sm border-b-2 border-red-800 mb-4">

    
      {({ isExpanded }) => (
      
      <>
        <h2>
          <AccordionButton>
            <Box as="span" flex='1' textAlign='left' className="text-2xl">
            Course Structure
            </Box>
            {isExpanded ? (
              <MinusIcon fontSize='16px' color='maroon' />
            ) : (
              <AddIcon fontSize='16px' color='maroon' />
            )}
          </AccordionButton>
        </h2>
       
       
       
       
       
        {/* <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left" fontWeight="medium" className="text-2xl">
              Eligibility Criteria
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2> */}
        {/* <AccordionPanel pb={4}>
          The minimum requirements for admission in a Bachelor degree program in
          Computer Science, is at least 50% marks in Intermediate (HSSC)
          examination with Mathematics or equivalent qualification with
          Mathematics certified by IBCC
        </AccordionPanel> */}
        </>
      )}
             </AccordionItem>
        </div>
  











       {/* <div>
      <AccordionItem className="w-[480px] h-fit border-2 border-black mb-4">
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left" fontWeight="medium">
              Duration
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          The minimum duration for completion of BS degree is four years. As per
          HEC rules, a maximum period of seven years is required to complete BS
          degree program.
        </AccordionPanel>
      </AccordionItem>
          </div> 
      <div>
         
      <AccordionItem className="w-[480px] h-fit border-2 border-black mb-4">
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left" fontWeight="medium">
              Degree Completion Requirements
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          <p>
            To become eligible for award of BS degree, a student must satisfy
            the following requirements:
          </p>
          <li>
            Must have studied and passed the prescribed courses, totaling at
            least 130 credit hours.
          </li>
          <li>
            Must have earned CGPA (Cumulative Grade Point Average) of at least
            2.0 on a scale of 4.0.
          </li>
        </AccordionPanel>
      </AccordionItem>
      </div> */}
    </Accordion>
      </div>
    </div>
    </>
  );
};

export default AccordionCard;
